import { Button } from '@spark-web/button';
import { Heading } from '@spark-web/heading';
import { Stack } from '@spark-web/stack';
import { FormProvider, useForm } from 'react-hook-form';
import { useFetcher } from 'react-router';

import { useLeadContext } from '~/provider/LeadProvider';
import { CustomerFormValues } from '~/types/marketplace';

import { Footer } from '../footer';
import { CallbackForm } from '../form/callback-form';
import { RequestQuoteForm } from '../form/request-quote-form';

type NeedHelpContentProps = {
  dialog: 'CALLBACK' | 'FORM' | null;
  onSuccess?: () => void;
};

type FetcherData = {
  error?: string;
};

export const NeedHelpContent = ({ dialog, onSuccess }: NeedHelpContentProps) => {
  const fetcher = useFetcher<FetcherData>();

  const { lead } = useLeadContext();
  const formMethods = useForm<CustomerFormValues>({
    mode: 'all',
  });

  const isLoading = fetcher.state !== 'idle';

  const onSubmit = (data: Partial<CustomerFormValues>) => {
    fetcher.submit(data, { method: 'post', action: '/api/marketplace/request-callback' });
  };

  if (fetcher?.data && !fetcher?.data?.error) {
    return (
      <Stack gap="xxlarge">
        <Heading level="3">Thanks, our team will be in contact soon.</Heading>
        <Stack gap="xlarge">
          <Button rounded tone="neutral" onClick={onSuccess}>
            Back to Marketplace
          </Button>
          <Footer />
        </Stack>
      </Stack>
    );
  }

  return (
    <fetcher.Form>
      {dialog === 'CALLBACK' ? (
        <CallbackForm onSubmit={(data) => onSubmit(data)} isLoading={isLoading} />
      ) : (
        <FormProvider {...formMethods}>
          <RequestQuoteForm isLoading={isLoading} onSubmit={onSubmit} error={fetcher?.data?.error} />
          <Footer />
        </FormProvider>
      )}
      <input type="hidden" name="leadId" value={lead?.id} />
    </fetcher.Form>
  );
};
